
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../environments/environment";
import { Product } from "../models/product.model";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})

export class ProductsService {

    public products: Product[] = [];

    public currentProduct: Product = new Product(0, "", "", 0, 0);

    setCurrentProduct(product: Product) {
        this.currentProduct = product;
    }

    getCurrentProduct() {
        return this.currentProduct;
    }

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {
    }

    fetchProducts() {
        const endpoint = environment.apiUrl + "/api/products/list";

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    updateProduct(product: Product ) {
        const endpoint = environment.apiUrl + "/api/products/update/" + product.id  ;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, product, {headers: new HttpHeaders().set("Authorization", bearerToken)})

    }

    addProduct(product: Product ) {
        const endpoint = environment.apiUrl + "/api/products/add";

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.post(endpoint, product, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    deleteProduct(product: Product ) {
        const endpoint = environment.apiUrl + "/api/products/delete/" + product.id;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken();

        return this.http.delete(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)});
    }

    getProductsCount() {
        const endpoint = environment.apiUrl + "/api/cbdok/count";

        const bearerToken = "Bearer " + this.authService.getToken();

        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization",bearerToken)});
    }

    checkProductByEan(ean: string | number) {
        const endpoint = environment.apiUrl + "/api/cbdok/check-ean/" + ean;

        const bearerToken = "Bearer " + this.authService.getToken();

        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization",bearerToken)});
    }

    checkProductByName(name: string) {
        const endpoint = environment.apiUrl + "/api/cbdok/search?q=" + name;

        const bearerToken = "Bearer " + this.authService.getToken();

        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization",bearerToken)});
    }
}